/**
 * Every media id a lesson refers to.
 *
 * Lessons reference media by id and never by URL (CLAUDE.md), so serving one
 * means resolving those ids to signed URLs at load time. This walks the
 * document rather than hard-coding the places media appears (a scene, a
 * voice-over, a poster): the schema grows, and a new field that quietly went
 * unsigned would show up as a blank panel in a classroom rather than as an
 * error. Shared: the API signs these ids, and the headset evicts a cached
 * photo whose id the API no longer signs.
 *
 * Matching the schema's own pattern for a media id keeps it honest -- it finds
 * ids, not every string that happens to be in the document.
 */
export const MEDIA_ID = /^m_[A-Za-z0-9_-]{1,64}$/;
export function collectMediaIds(lesson) {
    const found = new Set();
    const walk = (value) => {
        if (typeof value === 'string') {
            if (MEDIA_ID.test(value))
                found.add(value);
            return;
        }
        if (Array.isArray(value)) {
            for (const item of value)
                walk(item);
            return;
        }
        if (value !== null && typeof value === 'object') {
            for (const item of Object.values(value))
                walk(item);
        }
    };
    walk(lesson);
    return [...found].sort();
}
//# sourceMappingURL=media-ids.js.map